export default __webpack_public_path__ + "static/media/courses10.67e76be7.svg";